import { defineAction } from '~/prix'
import cboCollectAction from './cboCollect.action.json' with { type: 'json' }
import { z } from 'zod'

const cboCollectDefinition = defineAction({
  ...cboCollectAction,

  input: z.object({
    noOptimize: z.boolean().optional(),
  }),
  output: z.object({}),
})

export default cboCollectDefinition
